<template>
  <page-list :list="coverageList" :columns="riCoverageColumns" />
</template>

<script>
import ListMixin from '@/mixins/list'
import WindowsMixin from '@/mixins/windows'
import RiCoverageColumnsMixin from './mixins/riCoverageColumns'

export default {
  name: 'RiCoverage',
  mixins: [ListMixin, WindowsMixin, RiCoverageColumnsMixin],
  props: {
    cloudaccountId: {
      type: String,
      required: true,
    },
    dateParam: {
      type: Object,
      default: () => ({}),
    },
    listId: {
      type: String,
      default: 'riCoverageListForAccount',
    },
  },
  data () {
    return {
      riCoverageHiddenFields: ['external_id', 'sku', 'os', 'quantity', 'usage_factor'],
      coverageList: this.$list.createList(this, {
        id: this.listId,
        resource: 'bill_analysises/reservation',
        apiVersion: 'v1',
        getParams: this.getCoverageParam,
        noPreLoad: true,
        fetchDataCb: this.fetchCoverageDataCb,
      }),
    }
  },
  watch: {
    dateParam: {
      handler () {
        this.fetchData()
      },
      deep: true,
    },
  },
  created () {
    if (this.dateParam.start_day && this.dateParam.end_day) {
      this.fetchData()
    }
  },
  methods: {
    getCoverageParam () {
      return {
        cloudaccount_id: this.cloudaccountId,
        scope: this.$store.getters.scope,
        ...this.dateParam,
      }
    },
    fetchData () {
      this.coverageList.fetchData()
    },
    fetchCoverageDataCb (response) {
      const { coverage, usage_hours, utilization } = response.data || {}
      this.$emit('coverage-stats', { coverage, usage_hours, utilization })
    },
  },
}
</script>
